import { createFileRoute } from '@tanstack/react-router';

import { APICredentials } from '@/features/settings';

export const Route = createFileRoute('/_auth/_org/settings/api')({
  component: APICredentials,
  notFoundComponent: () => {
    return <p>API credentials not found!</p>;
  },
});
